import * as ActionTypes from './types.action';

export const setTemplate = template => ({
  type: ActionTypes.CHANGE_TEMPLATE_SUCCESS,
  template
});

function changeLanguageSuccess(language) {
  return {
    type: ActionTypes.CHANGE_LANGUAGE_SUCCESS,
    language
  };
}

export const changeLanguage = language => dispatch => {
  dispatch(changeLanguageSuccess(language));
};




// WEBPACK FOOTER //
// ./actions/settings.action.js